export const EnglishDict = {
    TO: '—',
    AROUND: 'around',
};
